import warning from 'warning';
var warned = {};
export default (function (valid, message) {
    if (!valid && !warned[message]) {
        warning(false, message);
        warned[message] = true;
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/_util/warning.js
// module id = 109
// module chunks = 0